import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconPaperPlane = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.937 23.938'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.836,0.656 C23.879,0.762 23.908,0.873 23.912,0.988 C23.913,0.994 23.910,1.001 23.910,1.007 C23.912,1.094 23.906,1.180 23.884,1.266 L18.905,21.184 C18.829,21.485 18.619,21.733 18.335,21.857 C18.208,21.912 18.073,21.939 17.939,21.939 C17.771,21.939 17.605,21.897 17.455,21.813 L12.888,19.276 C12.856,19.367 12.826,19.459 12.766,19.540 L9.845,23.523 C9.654,23.784 9.353,23.930 9.042,23.930 C8.940,23.930 8.837,23.915 8.737,23.882 C8.329,23.751 8.050,23.373 8.046,22.944 L7.980,15.973 C7.980,15.953 7.990,15.936 7.991,15.917 C7.992,15.888 8.001,15.860 8.007,15.831 C8.020,15.735 8.041,15.643 8.082,15.553 C8.085,15.547 8.085,15.540 8.088,15.533 C8.097,15.516 8.096,15.497 8.105,15.480 C8.126,15.443 8.159,15.420 8.184,15.387 C8.208,15.354 8.219,15.315 8.248,15.284 L18.415,4.390 L3.235,11.980 L6.120,13.422 C6.613,13.668 6.812,14.266 6.566,14.758 C6.320,15.250 5.722,15.450 5.230,15.204 L0.563,12.870 C0.226,12.702 0.013,12.357 0.013,11.980 C0.013,11.603 0.226,11.258 0.563,11.089 L22.472,0.134 C22.480,0.131 22.489,0.130 22.496,0.126 C22.521,0.115 22.546,0.111 22.571,0.102 C22.657,0.070 22.744,0.049 22.833,0.041 C22.868,0.038 22.900,0.037 22.935,0.038 C23.029,0.039 23.121,0.054 23.211,0.082 C23.232,0.088 23.253,0.090 23.274,0.098 C23.369,0.134 23.459,0.183 23.541,0.248 C23.553,0.258 23.560,0.271 23.572,0.281 C23.580,0.288 23.590,0.290 23.597,0.297 C23.613,0.311 23.618,0.331 23.632,0.346 C23.697,0.415 23.751,0.489 23.793,0.571 C23.808,0.600 23.824,0.626 23.836,0.656 ZM17.288,19.442 L21.017,4.521 L10.573,15.711 L17.288,19.442 ZM10.010,19.931 L11.160,18.362 C11.169,18.350 11.182,18.345 11.191,18.334 L9.988,17.665 L10.010,19.931 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconPaperPlane.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
